// DeitiesImageBox.js
import ImageWrapper from "../ImageComponent/ImageWrapper";
import { useState } from "react";

const DeitiesImageBox = ({ name, imageUrl, altText, categoryid, onClick }) => {
  const [isHovered, setISHovered] = useState(false);

  return (
    <div className="flex items-center justify-center relative cursor-pointer">
      <div
        className="w-[148px] h-[248px] md:w-[198px]  md:h-[298px] lg:w-[248px] lg:h-[348px] xl:w-[298px] xl:h-[398px] 2xl:w-352 2xl:h-493 z-10 overflow-hidden rounded-xl shadow-md bg-white hover:shadow-xl transition-all duration-300 relative"
        onMouseEnter={() => setISHovered(true)}
        onMouseLeave={() => setISHovered(false)}
      >
        <ImageWrapper
          src={imageUrl}
          alt={altText}
          className="h-full object-cover"
          onClick={() => onClick(categoryid)}
        />
        <div
          className={`absolute duration-200 left-0 bg-clip-padding w-full opacity-50 rounded-2xl md:rounded-xl bg-opacity-20 text-white tracking-wider ${
            isHovered ? "-top-0" : "-top-[150px]"
          }`}
        >
          <ImageWrapper src="/icons/Group6942.svg" alt="Deities design image" />
        </div>
        <div
          className={`${
            isHovered
              ? "bottom-4 xs:bottom-0"
              : "-bottom-14 xs:-bottom-16 sm:-bottom-[4.25rem] md:-bottom-[5.25rem] lg:-bottom-[5.75rem] xl:-bottom-[6.25rem]"
          } absolute duration-200 flex flex-col w-full`}
        >
          <div
            className={`text-base duration-300 sm:text-md md:text-xl lg:text-2xl xl:text-3xl font-bastoni bg-opacity-50 text-white w-full flex text-center justify-center md:pb-1 lg:pb-2 xl:pb-4 2xl:pb-5 px-2`}
          >
            {name?.slice(0, 15) + (name.length > 15 ? " ..." : "")}
          </div>

          <p
            className={`text-white duration-200 text-[10px] lg:text-xs xl:text-sm font-light flex flex-row justify-center py-2 lg:py-3 cursor-text`}
          ></p>
          <div className="flex duration-200 justify-center xs:pb-3 sm:pb-4 md:pb-5 lg:pb-6">
            <button
              onClick={() => onClick(categoryid)}
              className="flex flex-row items-center justify-center hover:bg-ModalTransparentColor text-white text-xxs md:text-[10px] lg:text-xs xl:text-sm py-2 px-4 md:py-3 md:px-5 lg:py-3 lg:px-6 xl:py-4 xl:px-8 border w-auto border-white rounded-lg"
            >
              EXPLORE POOJAS
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DeitiesImageBox;
